// extracted by mini-css-extract-plugin
export default {"ground-truth__toggle":"lsf-ground-truth__toggle","ground-truth__indicator":"lsf-ground-truth__indicator","ground-truth__indicator_active":"lsf-ground-truth__indicator_active","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380194
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  